var _excluded = ["title", "content"],
  _excluded2 = ["level"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { notification, message } from 'antd';
var NOTIFICATION = 'notification';
var ALERT = 'message';
var SUCCESS = 'success';
var INFO = 'info';
var LOADING = 'loading';
var WARN = 'warning';
var WARNING = 'warning';
var ERROR = 'error';
var getBroker = function getBroker() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var type = getType(options);
  if (type === NOTIFICATION) {
    return [notification, toNotificationOptions(options)];
  }
  return [message, toMessageOptions(options)];
};
var notificationOptions = ['title', 'placement', 'closeIcon', 'onClick', 'style'];
var getType = function getType(options) {
  if (options.type) {
    return options.type === NOTIFICATION ? NOTIFICATION : ALERT;
  }
  var notificationOptionKeyFound = !!Object.keys(options).find(function (key) {
    return notificationOptions.includes(key);
  });
  return notificationOptionKeyFound ? NOTIFICATION : ALERT;
};
var toNotificationOptions = function toNotificationOptions(options) {
  var title = options.title,
    content = options.content,
    rest = _objectWithoutProperties(options, _excluded);
  var notificationOptions = _objectSpread(_objectSpread({}, rest), {}, {
    message: title,
    description: content
  });
  delete notificationOptions.type;
  delete notificationOptions.level;
  return notificationOptions;
};
var toMessageOptions = function toMessageOptions(options) {
  var messageOptions = _objectSpread({}, options);
  ['type', 'level', 'title', 'placement', 'closeIcon', 'onClick', 'style'].forEach(function (key) {
    delete messageOptions[key];
  });
  return messageOptions;
};
var validate = function validate(options) {
  if (!options) {
    return {};
  }
  if (typeof options === 'string') {
    return {
      content: options
    };
  }
  if (_typeof(options) === 'object') {
    return options.content ? options : {
      content: options
    };
  }
  if (/*#__PURE__*/React.isValidElement(options)) {
    return {
      content: options
    };
  }
  return {};
};

/**
 * The options object for Messaging.
 * @typedef {Object} Messaging~Options
 * @property {string} [type] - Message type. One of ('notification'|'message').
 * @property {string} [level] - Message level. One of ('success'|'info'|'loading'|'warning'|'error').
 * @property {ReactNode} content - Content for the message.
 * @property {string} [key] - Message identifier.
 * @property {number} [duration] - Duration for auto-closing. Null means no auto-closing.
 * @property {function} [onClose] - Close callback.
 * @property {ReactNode} [icon] - Customized icon.
 * @property {ReactNode} [title] - Title for the message, only supported for notification type.
 * @property {string} [placement] - Only for notification type, location of the message. One of ('topLeft'|'topRight|'bottomLeft'|'bottomRight').
 * @property {ReactNode} [closeIcon] - Custom close icon.
 * @property {function} [onClick] - Click callback.
 * @property {object} [style] - Inline style.
 */

/**
 * Utility for showing global messages.
 *
 * @example
 * import { React } from 'react';
 * import { Message } from 'oskari-ui';
 * import { Messaging } from 'oskari-ui/util';
 *
 * // Simple usage
 * Messaging.open('Hello world');
 *
 * // The localized way
 * Messaging.open(<Message messageKey='hello' bundleKey='my-hello-world-bundle'/>);
 *
 * // Localized error message
 * Messaging.open({
 *     title: <Message messageKey='error.notfound.title' bundleKey='my-bundle'/>,
 *     content: <Message messageKey='error.notfound.content' bundleKey='my-bundle'/>,
 *     level: Messaging.LEVEL.ERROR
 * });
 *
 * // Localized error alert with a shortcut
 * Messaging.error(<Message messageKey='error.notfound.content' bundleKey='my-bundle'/>);
 */
var Messaging = /*#__PURE__*/function () {
  function Messaging() {
    _classCallCheck(this, Messaging);
    notification.config({
      placement: 'topLeft',
      top: 50,
      duration: 10
    });
  }
  /** @param {Messaging~Options} option */
  return _createClass(Messaging, [{
    key: "open",
    value: function open(options) {
      var validOptions = validate(options);
      if (!validOptions) {
        return;
      }
      var level = validOptions.level,
        rest = _objectWithoutProperties(validOptions, _excluded2);
      var _getBroker = getBroker(rest),
        _getBroker2 = _slicedToArray(_getBroker, 2),
        broker = _getBroker2[0],
        brokerOptions = _getBroker2[1];
      if (!level || !broker.hasOwnProperty(level)) {
        broker.open(brokerOptions);
        return;
      }
      broker[level](brokerOptions);
    }
    /** @param {Messaging~Options} options **/
  }, {
    key: "success",
    value: function success(options) {
      this.open(_objectSpread(_objectSpread({}, validate(options)), {}, {
        level: SUCCESS
      }));
    }
    /** @param {Messaging~Options} options */
  }, {
    key: "info",
    value: function info(options) {
      this.open(_objectSpread(_objectSpread({}, validate(options)), {}, {
        level: INFO
      }));
    }
    /** @param {Messaging~Options} options */
  }, {
    key: "alert",
    value: function alert(options) {
      this.info(_objectSpread(_objectSpread({}, validate(options)), {}, {
        type: ALERT
      }));
    }
    /** @param {Messaging~Options} options */
  }, {
    key: "notify",
    value: function notify(options) {
      this.info(_objectSpread(_objectSpread({}, validate(options)), {}, {
        type: NOTIFICATION
      }));
    }
    /** @param {Messaging~Options} options */
  }, {
    key: "warn",
    value: function warn(options) {
      this.warning(options);
    }
    /** @param {Messaging~Options} options */
  }, {
    key: "warning",
    value: function warning(options) {
      this.open(_objectSpread(_objectSpread({}, validate(options)), {}, {
        level: WARNING
      }));
    }
    /** @param {Messaging~Options} options */
  }, {
    key: "error",
    value: function error(options) {
      this.open(_objectSpread(_objectSpread({}, validate(options)), {}, {
        level: ERROR
      }));
    }
    /** @param {Messaging~Options} options */
  }, {
    key: "loading",
    value: function loading(options) {
      this.open(_objectSpread(_objectSpread({}, validate(options)), {}, {
        level: LOADING
      }));
    }
    /** @param {string} key */
  }, {
    key: "close",
    value: function close(key) {
      notification.destroy(key);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      notification.destroy();
      message.destroy();
    }
  }]);
}();
/**
 * @property {string} NOTIFICATION Notification with a title.
 * @property {string} ALERT Message box on upper-center.
 * @property {string} MESSAGE Alias for ALERT.
 * @memberof Messaging
 **/
var TYPE = {
  NOTIFICATION: NOTIFICATION,
  ALERT: ALERT,
  MESSAGE: ALERT
};
Object.defineProperty(Messaging, 'TYPE', {
  value: TYPE,
  writable: false,
  enumerable: true,
  configurable: false
});

/**
 * @property {string} SUCCESS Message with success icon.
 * @property {string} INFO Message with info icon.
 * @property {string} LOADING Message with warning loading icon. Only valid for ALERT and MESSAGE types.
 * @property {string} WARN Alias for WARNING.
 * @property {string} WARNING Message with warning icon.
 * @property {string} ERROR Message with error icon.
 * @memberof Messaging
 **/
var LEVEL = {
  SUCCESS: SUCCESS,
  INFO: INFO,
  LOADING: LOADING,
  WARN: WARN,
  WARNING: WARNING,
  ERROR: ERROR
};
Object.defineProperty(Messaging, 'LEVEL', {
  value: LEVEL,
  writable: false,
  enumerable: true,
  configurable: false
});
var MessagingSingleton = new Messaging();
export { MessagingSingleton as Messaging };